import React from 'react';
import { createRoot } from 'react-dom/client';
import ChatWidget from './components/chat-widget.js';

// Функция инициализации виджета
function initChatWidget(config = {}) {
  const containerId = 'misoft-chat-widget';
  let container = document.getElementById(containerId);
  
  if (!container) {
    container = document.createElement('div');
    container.id = containerId;
    document.body.appendChild(container);
  }

  const root = createRoot(container);
  root.render(<ChatWidget config={config} />);
}

// Читает параметры из URL скрипта (например ?tokenCode=xxx)
function getParamsFromScriptUrl() {
  const script = document.currentScript;
  if (!script || !script.src) return {};
  try {
    const url = new URL(script.src);
    const params = {};
    url.searchParams.forEach((value, key) => {
      params[key] = value;
    });
    return params;
  } catch (e) {
    return {};
  }
}

// Автоматическая инициализация при загрузке скрипта
if (typeof window !== 'undefined') {
  window.MisoftChatWidget = {
    init: initChatWidget
  };

  const urlParams = getParamsFromScriptUrl();
  const configFromUrl = {
    ...(urlParams.tokenCode != null && { tokenCode: urlParams.tokenCode }),
    ...(urlParams.chatHubUrl != null && { chatHubUrl: urlParams.chatHubUrl })
  };
  const config = { ...window.MISOFT_CHAT_CONFIG, ...configFromUrl };

  if (config.tokenCode) {
    initChatWidget(config);
  } else if (window.MISOFT_CHAT_CONFIG && window.MISOFT_CHAT_CONFIG.tokenCode) {
    initChatWidget(window.MISOFT_CHAT_CONFIG);
  }
}

export default initChatWidget;
